import * as React from "react";
import axios from "axios";

import { useNavigate, useParams, Link } from "react-router-dom";

import Textfield from "../../../Components/Textfield";
import Button from "../../../Components/Button";
import Paper from "../../../Components/Paper";
import TopBarNotConnected from "../../../Components/TopBarNotConnected";

import { useToast } from "../../../Context/ToastContext";
import { useLoader } from "../../../Context/LoaderContext";
import { useConnectedUser } from "../../../Context/ConnectedUserContext";

import "./SimulateurStep2NotConnected.scss";

const initialFormState = {
  first_name: "",
  last_name: "",
  email: "",
  phone_number: "",
};

const SimulateurStep2NotConnected = () => {
  const [valRegister, setValRegister] = React.useState(initialFormState);

  const [formErrorMessages, setFormErrorMessages] = React.useState("");

  const navigate = useNavigate();
  const { addToast } = useToast();
  const { user } = useConnectedUser();
  const { setIsLoading } = useLoader();
  const { id } = useParams();

  const handleChangeField = (e, key) => {
    setFormErrorMessages((prev) => ({
      ...prev,
      [key]: "",
    }));
    setValRegister((prev) => ({
      ...prev,
      [key]: e.target.value,
    }));
  };

  React.useEffect(() => {
    setIsLoading(true);

    axios
      .get(`${process.env.REACT_APP_API_URL}/simulation/${id}/show`)
      .then((response) => {
        setIsLoading(false);
        setValRegister(response.data.data.simulation || []);
      })
      .catch(() => {
        setIsLoading(false);
      });
  }, [id, setIsLoading]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    axios
      .post(`${process.env.REACT_APP_API_URL}/simulation/store/${id}`, {
        first_name: valRegister.first_name,
        last_name: valRegister.last_name,
        email: valRegister.email,
        phone_number: valRegister.phone_number,
        step: 2,
      })
      .then((response) => {
        setIsLoading(false);

        if (response.data.status) {
          addToast({
            variant: "success",
            message: response.data.message,
          });
          navigate("/list-financing-request");
        }
      })
      .catch((error) => {
        setIsLoading(false);

        if (error.response.data.errors) {
          setFormErrorMessages(error.response.data.errors);
        } else {
          addToast({
            variant: "danger",
            message: error.response.data.message,
          });
        }
      });
  };

  const Stepsimulation = valRegister.step;

  return (
    <div className="layout-app">
      <div className="wrap-app">
        <TopBarNotConnected />
        <div className="container-app">
          {/* <div className="back-home">
        <Link to="/list-simulations" className="link-back">
          <RiArrowLeftLine />
        </Link>
      </div> */}
          <h1>Simulateur Étape 2</h1>
          <p>Veuillez remplir les champs ci dessous</p>
          <Paper>
            <div className="stepper-wrapper">
              <div className="completed stepper-item">
                {Stepsimulation >= 1 ? (
                  <Link to={`/list-financing-request/simulateur-step-1/${id}`}>
                    <div className="step-counter">1</div>
                    <div className="step-name">Étape</div>
                  </Link>
                ) : (
                  <>
                    <div className="step-counter">1</div>
                    <div className="step-name">Étape</div>
                  </>
                )}
              </div>

              <div className="active stepper-item">
                <div className="step-counter">2</div>
                <div className="step-name">Étape</div>
              </div>
            </div>

            <div className="step-simulateur">
              <h4 className="bold">Données Personnelles</h4>
              <form
                className="register-form"
                onSubmit={handleSubmit}
                noValidate
              >
                <Textfield
                  autoComplete="off"
                  label="Nom"
                  name="first_name"
                  type="text"
                  placeholder="Veuillez insérer votre nom"
                  size="large"
                  value={valRegister.first_name ?? user?.name}
                  onChange={(e) => handleChangeField(e, "first_name")}
                  hasError={formErrorMessages.first_name}
                  errorMessage={
                    formErrorMessages.first_name && (
                      <div className="text-danger">
                        {formErrorMessages.first_name}
                      </div>
                    )
                  }
                />
                <Textfield
                  autoComplete="off"
                  label="Prénom"
                  name="last_name"
                  type="text"
                  placeholder="Veuillez insérer votre prénom"
                  size="large"
                  value={valRegister.last_name}
                  onChange={(e) => handleChangeField(e, "last_name")}
                  hasError={formErrorMessages.last_name}
                  errorMessage={
                    formErrorMessages.last_name && (
                      <div className="text-danger">
                        {formErrorMessages.last_name}
                      </div>
                    )
                  }
                />

                <Textfield
                  autoComplete="off"
                  label="Email"
                  name="email"
                  type="text"
                  placeholder="Veuillez insérer votre email"
                  size="large"
                  value={valRegister.email ?? user?.email}
                  onChange={(e) => handleChangeField(e, "email")}
                  hasError={formErrorMessages.email}
                  errorMessage={
                    formErrorMessages.email && (
                      <div className="text-danger">
                        {formErrorMessages.email}
                      </div>
                    )
                  }
                />
                <Textfield
                  autoComplete="off"
                  label="Numéro de téléphone"
                  name="phone_number"
                  type="number"
                  placeholder="Veuillez insérer votre numéro de téléphone"
                  size="large"
                  value={valRegister.phone_number ?? user?.phone_number}
                  onChange={(e) => handleChangeField(e, "phone_number")}
                  onKeyDown={(e) => {
                    if (
                      e.key === "e" ||
                      e.key === "+" ||
                      e.key === "-" ||
                      e.key === "."
                    ) {
                      e.preventDefault();
                    }
                  }}
                  hasError={formErrorMessages.phone_number}
                  errorMessage={
                    formErrorMessages.phone_number && (
                      <div className="text-danger">
                        {formErrorMessages.phone_number}
                      </div>
                    )
                  }
                />

                <div className="wrap_actions_form">
                  <Button type="submit" size="lg">
                    Envoyer
                  </Button>
                </div>
              </form>
            </div>
          </Paper>
        </div>
      </div>
    </div>
  );
};

export default SimulateurStep2NotConnected;
